import { IonButton } from "@ionic/react";

interface Props {
  enabled: boolean;
  onClose?: (isEnabled: boolean) => void;
  onSkip?: (isEnabled: boolean) => void;
}

const RtmEnabledModal: React.FC<Props> = ({ enabled, onClose, onSkip }) => {
  return (
    <>
      <div className="py-32 ph-42 text-center flex-column">
        <svg
          className="mb-24"
          xmlns="http://www.w3.org/2000/svg"
          width="145"
          height="146"
          viewBox="0 0 145 146"
          fill="none"
        >
          <path
            d="M72.5 138C108.399 138 137.5 108.899 137.5 73C137.5 37.1015 108.399 8 72.5 8C36.6015 8 7.5 37.1015 7.5 73C7.5 108.899 36.6015 138 72.5 138Z"
            fill="#0F854C"
            stroke="#0F854C"
            stroke-width="14.4444"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M94.1654 58.5557L65.2765 87.4446L50.832 73.0001"
            stroke="white"
            stroke-width="14.4444"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <p className="generic-heading-32 fw-700 mb-16">
          {enabled ? "RTM Enabled!" : "RTM Disabled!"}
        </p>
        <p className="generic-heading-32 fw-400 mb-24">
          {enabled
            ? "To complete setup, you’ll need to create an exercise plan."
            : ""}
        </p>
        <div className="d-flex justify-content-center gap-24">
          {enabled ? (
            <>
              <IonButton
                placeholder={undefined}
                className="generic-btn-outline mb-0 h-64 fz-26"
                onClick={() => onSkip && onSkip(true)}
              >
                Skip Exercise Plan
              </IonButton>
              <IonButton
                placeholder={undefined}
                className="generic-btn mb-0 h-64 fz-26"
                onClick={() => onClose && onClose(true)}
              >
                {" "}
                Create Exercise Plan
              </IonButton>
            </>
          ) : (
            <IonButton
              placeholder={undefined}
              className="generic-btn mb-0 h-64 fz-26"
              onClick={() => onClose && onClose(false)}
            >
              {" "}
              Close
            </IonButton>
          )}
        </div>
      </div>
    </>
  );
};
export default RtmEnabledModal;
